/**
 * Create BarcodeReader configuration
 *
 * @param hostElem The host element hosting the BarcodeReader
 */

import { StrichSDK } from "@pixelverse/strichjs-sdk";

export function createBarcodeReaderConfig(hostElem) {
  // see: https://docs.strich.io/reference/interfaces/Configuration.html
  return {
    selector: hostElem,
    engine: {
      symbologies: [
        { name: "qr", curved: true }
      ], // this is just an example: enable only what you need!
      duplicateInterval: 2500,
    },
    frameSource: {
      rememberCameraDeviceId: true,
    },
    overlay: {
      cornerRadius: 8,
      detectionBorderWidth: 4,
    },
    feedback: {
      audio: {
        enabled: true,
        },
      vibration: true,
    },
    locator: {
      chromaReject: true,
      regionOfInterest: {
        // restrict active area to a square-shaped region in the center
        left: 0.1,
        right: 0.1,
        top: 0.35,
        bottom: 0.2,
      },
    },
  };
}

/**
 * The STRICH SDK license key, see: https://docs.strich.io/getting-started.html#creating-a-license-key
 */
export function sdkLicenseKey() {
  return import.meta.env.VITE_SDK_LICENSE_KEY;
}
